'use client'

import DownloadIcon from 'public/icons/interface/download.svg'
import FileIcon from 'public/icons/interface/file2.svg'
import { getMediaUrl } from 'src/_helpers/client/getMediaUrl'
import { getPreferredTranslation } from 'src/_helpers/getPreferredTranslation'
import { normalizeCollection } from 'src/_helpers/normalizeCollection'
import { formatFileSize } from 'src/_helpers/formatFileSize'
import Typography from 'src/components/design-system/Typography'
import { useTranslateEntry } from 'src/i18n/client/useTranslateEntry'
import DownloadFile from 'src/components/items/DownloadFile'

export default function Files({ block, locale, variant = '' }) {
  const translateEntry = useTranslateEntry()
  const blockTranslation = getPreferredTranslation(block, locale) || {}
  const mainTitle = blockTranslation?.title
  const files = normalizeCollection(block.files)
  const filesOpen = normalizeCollection(block.filesOpen)
  const sourceFiles = files.length > 0 ? files : filesOpen
  const downloadLabel = translateEntry('T_DOWNLOAD') || 'Pobierz'
  const fallbackTitle = translateEntry('T_FILE_NO_TITLE') || 'Brak tytułu'
  const entries = sourceFiles
    .map((file) => {
      const media = file?.file || file
      const mediaUrl = file?.downloadUrl
        ? getMediaUrl(file?.downloadUrl)
        : media?.url
          ? getMediaUrl(media.url, media.version)
          : null
      if (!mediaUrl) return null
      const fileSize = file?.fileMetadata?.filesize || media.size
      const extension = file?.fileMetadata?.extension || media.extension || media.ext || ''

      const translation = getPreferredTranslation(file, locale) || {}
      const title = translation?.title || fallbackTitle
      const size = fileSize ? formatFileSize(fileSize) : null
      const href = mediaUrl
      const meta = [extension && extension.toUpperCase(), size].filter(Boolean).join(' ')
      return { href, title, meta, openInBrowser: extension.toLowerCase() === 'pdf' }
    })
    .filter(Boolean)

  return (
    <section
      className={`${variant !== 'article' ? 'bg-dark-blue-dark-blue6' : 'my-64 d:my-80 max-w-[777px]'} ${block.type.value}`}
      id={`${block.uuid}`}
    >
      <div className={`w-full ${variant !== 'article' ? 'max-w-screen-2xl px-16 py-80 d:px-40 mx-auto' : ''}`}>
        {mainTitle && (
          <Typography
            variant={variant === 'article' ? 'h2' : 'h2-bold'}
            color={variant === 'article' ? 'text-basic-black' : 'text-dark-blue-dark-blue1'}
            className="t:mb-64 mb-32"
          >
            {mainTitle}
          </Typography>
        )}

        <div className="grid grid-cols-1 gap-x-40 t:gap-y-80 gap-y-24 t:grid-cols-2 d:grid-cols-4">
          {entries.map((item, index) => (
            <DownloadFile
              key={`${item.href}-${index}`}
              href={item.href}
              title={item.title}
              meta={item.meta}
              downloadLabel={downloadLabel}
              DownloadIcon={DownloadIcon}
              FileIcon={FileIcon}
              color={variant === 'article' ? 'journalDomain' : 'default'}
              openInBrowser={item.openInBrowser}
            />
          ))}
        </div>
      </div>
    </section>
  )
}
